export const CheckScope = (token, scope) => {
    let hasScope = false;
    if (token) {
      let tokenDetails = JSON.parse(atob(token.token.split(".")[1]));
      hasScope = tokenDetails.scopes.includes(scope);
    }
    return hasScope;
  }
